import { Box } from "@mui/material";
import React from "react";

export default function CustomDivider(props) {
  const { className = "" } = props;
  return (
    <Box
      component="hr"
      className={`border-pami-orange-default my-2 ${className}`}
    />
  );
}
